export const paymentServiceVersion = '/v1';
